export const ANIME_CALL_REQUEST = "ANIME_CALL_REQUEST";
export const ANIME_CALL_SUCCESS = "ANIME_CALL_SUCCESS";
export const ANIME_CALL_FAILURE = "ANIME_CALL_FAILURE";
